import React, { useEffect, useState } from 'react';

const InstallPWA = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            // Evita que Chrome muestre el mini-banner por defecto
            e.preventDefault();
            // Guardamos el evento para dispararlo cuando el usuario haga clic
            setDeferredPrompt(e);
            // Actualizamos el estado para mostrar nuestro botón
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        
        // Mostramos el prompt de instalación nativo
        deferredPrompt.prompt();
        
        // Esperamos la respuesta del usuario
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            console.log('El alumno instaló la app con éxito 🚀');
        } else {
            console.log('El alumno canceló la instalación');
        }
        
        // Limpiamos el evento (solo se puede usar una vez)
        setDeferredPrompt(null);
        setIsInstallable(false);
    };

    // Si la app ya está instalada o el navegador no lo soporta, no mostramos nada
    if (!isInstallable) return null;

    return (
        <button 
            onClick={handleInstallClick} 
            className="dp-neumorphic"
            style={{
                padding: '8px 16px',
                backgroundColor: '#ffd700', /* Amarillo característico */
                color: '#1a1a1a',
                fontWeight: 'bold',
                borderRadius: '20px',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '15px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '0.9rem'
            }}
        >
            📱 Instalar App
        </button>
    );
};

export default InstallPWA;